import { API } from 'services/apiResource';
import apiServices from 'services/apiServices';
import {
    GET_ACCOUNTS,
    CLOSE_BROWER_SUCCESS,
    CLOSING_BROWER,
    OPENING_BROWER,
    OPEN_BROWER_SUCCESS,
    UPDATE_ACCOUNTS,
    SELECTED_ACCOUNT,
    ADD_LIST_ACCOUNT,
    REMOVE_LIST_ACCOUNT,
    SELECTED_DEFAULT,
    SET_ACCOUNTS_FOR_ACTION,
    REMOVE_ACCOUNT_FOR_ACTION,
    GET_ACCOUNTS_BY_ID_GROUP,
    SET_ACCOUNTS_BY_ID_GROUP,
    SET_ACCOUNT_SHARED,
    SET_ACCOUNT_SHARE_WITH_ME,
    SET_SCAN_ACCOUNT,
} from '@jumbo/constants/ActionTypes';
import { fetchError, fetchStart, fetchSuccess } from 'redux/actions/Common';
import { EventName } from '@jumbo/constants/electron/EventName';
import delay from 'helpers/delay';
import { notificationSuccess } from './Notification';
import { setClosePopupInfoAccount } from './infoAccountPopup';
import handleRequest from 'helpers/handleRequest';

const { ipcRenderer } = window.require('electron');

export const getAccounts = isStartEvent => {
    return async dispatch => {
        handleRequest(async () => {
            dispatch(fetchStart());
            let { rows, error } = await apiServices.get(API.ACCOUNTS.showAll);
            if (rows) {
                return rows
            }
            throw error;
        }, async (rows) => {
            dispatch(fetchSuccess());
            dispatch({
                type: GET_ACCOUNTS,
                payload: rows,
            });
        }, dispatch)
    };
};
export const updateAccount = data => {
    return async dispatch => {
        handleRequest(async () => {
            dispatch(fetchStart());
            let { msg, data: account, error } = await apiServices.put(`${API.ACCOUNTS.updateAccount}/${data._id}`, data);
            if (msg) {
                return account;
            }
            throw error;
        }, account => {
            delete data.state;
            for (const key in account) {
                data[key] = account[key];
            }
            dispatch(fetchSuccess('Cập nhật tài khoản thành công !'));
            dispatch({
                type: UPDATE_ACCOUNTS,
                payload: data,
            });
            dispatch(setClosePopupInfoAccount());
        }, dispatch);
    };
};

export const openingBrowserWithAction = (dataAccount, action, script, groupAction) => {
    const { proxy } = dataAccount;
    if (proxy) {
        proxy.username = 'proxyus';
        proxy.password = 'Scp#1234$';
    }

    const handleArray = async (dispatch) => {
        for (let i = 0; i < dataAccount.length; i++) {
            let element = dataAccount[i];
            element.i = i;
            if (element.state === 2) {
                return dispatch(fetchError(`${element.uuid ? element.uuid : element.email} browser opened`));
            }
            if (element.state == 1) {
                return;
            }
            dispatch({
                type: OPENING_BROWER,
                payload: { _id: element._id, state: 1 },
            });
            ipcRenderer.send(EventName.SendOpenBrowser, {
                ...element,
                actionType: action,
                groupAction: groupAction,
                script,
            });
            await delay(4000);
        }
    }

    const handleObject = (dispatch) => {
        if (dataAccount.state === 2) {
            return dispatch(fetchError(`${dataAccount.uuid ? dataAccount.uuid : dataAccount.email} browser opened`));
        }
        if (dataAccount.state == 1) {
            return dispatch(fetchError(`${dataAccount.email ? dataAccount.email : dataAccount.uuid} browser is busy`));
        }
        ipcRenderer.send(EventName.SendOpenBrowser, {
            ...dataAccount,
            actionType: action,
            groupAction: groupAction,
            script,
        });
    }

    return async dispatch => {
        if (dataAccount instanceof Array) {
            await handleArray(dispatch);
            return;
        }

        handleObject(dispatch);
    };
};
export const listenOpenBrowser = () => {
    return dispatch => {
        ipcRenderer.on(EventName.GetOpenBrowser, (event, { _id }) => {
            dispatch({ type: OPEN_BROWER_SUCCESS, payload: { _id, state: 2 } });
        });
    };
};
export const listenUpdateAccounts = () => {
    return dispatch => {
        ipcRenderer.on(EventName.UpdateStatusAccount, async (event, arg) => {
            handleRequest(async () => {
                delete arg.state;
                let { msg, data, error } = await apiServices.put(`${API.ACCOUNTS.updateAccount}/${arg._id}`, arg);
                if (!msg) {
                    throw error;
                }
                for (const key in data) {
                    arg[key] = data[key];
                }
                return arg;
            }, data => {
                dispatch({
                    type: UPDATE_ACCOUNTS,
                    payload: data
                });
            }, dispatch);
        }, dispatch);
    };
};

export const listenCheckAccountFB = () => {
    return dispatch => {
        ipcRenderer.on(EventName.statusCheckCookie, async (event, arg) => {
            const formatDataCheck = () => {
                return {
                    type: SET_SCAN_ACCOUNT,
                    payload: {
                        error: Number(!!arg.status),
                        success: Number(!arg.status),
                        total: arg.totalSelected
                    }
                };
            }

            let dataScanAccount = formatDataCheck();
            handleRequest(async () => {
                let { msg, data, error } = await apiServices.put(`${API.ACCOUNTS.updateAccount}/${arg._id}`, arg);
                if (!msg) {
                    dataScanAccount.payload.error = 1;
                    dataScanAccount.payload.success = 0;
                    throw error;
                }
                return data;
            }, (data) => {
                for (const key in data) {
                    arg[key] = data[key];
                }
                dispatch({
                    type: UPDATE_ACCOUNTS,
                    payload: arg
                });
            }, dispatch);
            dispatch(dataScanAccount);
        });
    };
};

export const closedBrowser = ({ _id }) => {
    return async dispatch => {
        dispatch({ type: CLOSING_BROWER, payload: { _id, state: 0 } });
        ipcRenderer.send(`${EventName.CloseBrowser}:${_id}`, { _id });
    };
};

export const clearAllInterval = ({ _id }) => {
    return dispatch => {
        ipcRenderer.send(EventName.clearInterval, { _id });
    };
};
export const listenCloseBrowser = () => {
    return dispatch => {
        ipcRenderer.on(EventName.GetCloseBrowser, (event, { _id }) => {
            dispatch({ type: CLOSE_BROWER_SUCCESS, payload: { state: 0, _id } });
        });
    };
};

export const listenOpeningBrowser = () => {
    return dispatch => {
        ipcRenderer.on(EventName.GetOpeningBrowser, (event, { _id }) => {
            dispatch({ type: OPENING_BROWER, payload: { state: 1, _id } });
        });
    };
};
export const addListAccountAction = data => {
    return dispatch => {
        dispatch({ type: ADD_LIST_ACCOUNT, payload: data });
    };
};

export const removeListAccountAction = data => {
    return dispatch => {
        dispatch({ type: REMOVE_LIST_ACCOUNT, payload: data });
    };
};

export const cleanListen = eventName => {
    return () => {
        ipcRenderer.removeAllListeners(eventName);
    };
};
export const listAccountSelected = data => {
    return dispatch => {
        dispatch({ type: SELECTED_ACCOUNT, payload: data });
    };
};
export const createAccountFacebook = data => {
    return async dispatch => {
        handleRequest(async () => {
            dispatch(fetchStart());
            let { msg, error } = await apiServices.post(`${API.ACCOUNTS.createAccount}`, data);
            if (!msg) {
                throw error;
            }
        }, () => {
            dispatch(getAccounts());
            dispatch(notificationSuccess('Tạo thành công tài khoản !'));
        }, dispatch);
    };
};
export const deleteAccountFacebook = data => {
    return async dispatch => {
        handleRequest(async () => {
            dispatch(fetchStart());
            let { msg, error } = await apiServices.delete(`${API.ACCOUNTS.deleteAccount}`, data);
            if (!msg) {
                throw error;
            }
        }, () => {
            let { ids } = data;
            ids.forEach(_id => {
                dispatch(closedBrowser({ _id }));
                dispatch(removeAccountForAction({ _id }));
                ipcRenderer.send(EventName.clearProfile, { _id });
            })

            dispatch(getAccounts());
            dispatch(notificationSuccess('Xóa thành công tài khoản!'));
            dispatch({ type: SELECTED_DEFAULT, payload: { start: 0, end: 0 } });
        }, dispatch);
    };
};
export const setAccountsForAction = data => {
    return dispatch => {
        dispatch({ type: SET_ACCOUNTS_FOR_ACTION, payload: data });
    };
};
export const removeAccountForAction = data => {
    return dispatch => {
        dispatch({ type: REMOVE_ACCOUNT_FOR_ACTION, payload: data });
    };
};
export const getAccountsByIdGroup = id => {
    return async dispatch => {
        handleRequest(async () => {
            dispatch(fetchStart());
            let { rows, error } = await apiServices.get(`${API.ACCOUNTS.getAccountsByIdGroup}/${id}`);
            if (!rows) {
                throw error;
            }
            return rows;
        }, (rows) => {
            dispatch(fetchSuccess());
            dispatch({ type: GET_ACCOUNTS_BY_ID_GROUP, payload: rows });
        }, dispatch)
    };
};

export const setAccountsByIdGroup = data => {
    return dispatch => {
        dispatch({ type: SET_ACCOUNTS_BY_ID_GROUP, payload: data });
    };
};

export const getAccountShared = (is_show_dialog) => {
    return async dispatch => {
        handleRequest(async () => {
            let { rows, error } = await apiServices.get(`${API.ACCOUNTS.getAccountShared}`);
            if (!rows) {
                throw error;
            }
            return rows;
        }, data => {
            dispatch({ type: SET_ACCOUNT_SHARED, payload: data });
        }, dispatch);
    }
}

export const getAccountShareWithMe = () => {
    return async dispatch => {
        handleRequest(async () => {
            dispatch(fetchStart());
            let { rows, error } = await apiServices.get(`${API.ACCOUNTS.getAccountShareWithMe}`);
            if (!rows) {
                throw error;
            }
            return rows;
        }, (rows) => {
            dispatch(fetchSuccess());
            dispatch({ type: SET_ACCOUNT_SHARE_WITH_ME, payload: rows });
        }, dispatch);
    }
}
